import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import FlexItem from "@insite/content-library/Widgets/Brand/FlexItem";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import LazyImage from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import React from "react";
import { css } from "styled-components";

const enum fields {
    image = "image",
    heading = "heading",
    text = "text",
}

interface OwnProps extends WidgetProps{
    fields:{
        [fields.image]: string;
        [fields.text]: string;
        [fields.heading]: string;
    }
}

export interface ServicePageCardStyles {
    wrapper?: InjectableCss;
    img?: InjectableCss;
    imgWrapper?: InjectableCss;
    heading?: TypographyPresentationProps;
    text?: InjectableCss;
    maintxt?: InjectableCss;
    mainwrapper?: InjectableCss;
}

export const servicePageCardStyles: ServicePageCardStyles = {
    imgWrapper:{
        css:css`
            padding: 15px 15px 15px 0;
            text-align: center;
        `,
    },
    img:{
        css:css`
            display: inline-block;
            vertical-align: middle;
        `,
    },
    maintxt:{
        css:css`
            padding: 15px;
        `,
    },
    text:{
        css:css`
            width: 80%;
            margin:7px;
        `,
    },
    heading:{
        css:css`
            font-weight: 800;
        `,
    },
};

const styles = servicePageCardStyles;

const ServicePageCards: React.FC<OwnProps> = ({ fields }) => {
    return(
        <>
            <StyledWrapper {...styles.wrapper}>
                <StyledWrapper {...styles.imgWrapper}>
                    <LazyImage src={fields.image} {...styles.img}></LazyImage>
                </StyledWrapper>
                <StyledWrapper {...styles.maintxt}>
                    <StyledWrapper {...styles.heading}>{fields.heading}</StyledWrapper>
                    <StyledWrapper {...styles.text}>{parse(fields.text, parserOptions)}</StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>  
        </>
    );
};

const widgetModule: WidgetModule = {
    component: ServicePageCards,
    definition: {
        group: "Basic",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.image,
                displayName: "Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.heading,
                displayName: "Heading",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.text,
                displayName: "Text",
                editorTemplate: "RichTextField",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;